import { Action } from '@ngrx/store'
import * as MobileSettingsTypes from './mobile-settings.types'

export class FetchMobileSettingsRequest implements Action {
  readonly type = MobileSettingsTypes.FETCH_MOBILE_SETTINGS_REQUEST
  constructor() {}
}

export class FetchMobileSettingsSuccess implements Action {
  readonly type = MobileSettingsTypes.FETCH_MOBILE_SETTINGS_SUCCESS
  constructor(public payload: any) {}
}

export class FetchMobileSettingsFailure implements Action {
  readonly type = MobileSettingsTypes.FETCH_MOBILE_SETTINGS_FAILURE
  constructor(public payload: any) {}
}

export class UpdateMobileSettingsRequest implements Action {
  readonly type = MobileSettingsTypes.UPDATE_MOBILE_SETTINGS_REQUEST
  constructor(public payload: any) {}
}

export class UpdateMobileSettingsSuccess implements Action {
  readonly type = MobileSettingsTypes.UPDATE_MOBILE_SETTINGS_SUCCESS
  constructor() {}
}

export class UpdateMobileSettingsFailure implements Action {
  readonly type = MobileSettingsTypes.UPDATE_MOBILE_SETTINGS_FAILURE
  constructor(public payload: any) {}
}

export class UpdateField implements Action {
  readonly type = MobileSettingsTypes.UPDATE_FIELD
  public constructor(
    public field: string,
    public value: any,
    public path: string,
  ) {}
}

export class SetDefaultData implements Action {
  readonly type = MobileSettingsTypes.SET_DEFAULT_DATA
  public constructor(public path: string) {}
}

export type Actions =
  | FetchMobileSettingsSuccess
  | FetchMobileSettingsFailure
  | FetchMobileSettingsRequest
  | UpdateMobileSettingsRequest
  | UpdateMobileSettingsSuccess
  | UpdateMobileSettingsFailure
  | SetDefaultData
  | UpdateField
